module.exports = __webpack_public_path__ + "img/b029a3512fa3fac90eea13fe38021eb6.png";